jQuery(function($) {

  $(document).ready(function() {

    $('.menu-toggle, .menu-close').click( function() {
      $('body').toggleClass('menu-open');
    });

    $('.jetsi-faqs .tab').click( function(e) {
      console.log( $(this).data('target') );
      $('.faq-category, .jetsi-faqs .tab').removeClass('active');
      $(this).addClass('active');
      $('#'+$(this).data('target')).addClass('active');
    });

    $('.faq .question').click( function(e) {
      $(this).toggleClass('active');
    });

    var photoGalleryPage = $('.single-jetsi_photo_gallery');

    if ( photoGalleryPage.length ) {
      $('.photo-gallery .carousel', photoGalleryPage).slick({
        prevArrow: '<div class="slick-prev"><i class="fa-solid fa-chevron-left"></i></div>',
        nextArrow: '<div class="slick-next"><i class="fa-solid fa-chevron-right"></i></div>',
        centerMode: true,
        variableWidth: true,
        asNavFor: '.photo-gallery-thumbnails .carousel'
      });
      $('.photo-gallery-thumbnails .carousel', photoGalleryPage).slick({
        arrows: false,
        centerMode: true,
        slidesToShow: 5,
        slidesToScroll: 5,
        asNavFor: '.photo-gallery .carousel',
        focusOnSelect: true,
        centerPadding: 0,
        swipeToSlide: true
      });
    }

    const modalTriggers = document.querySelectorAll('.popup-trigger')
    const modalCloseTrigger = document.querySelector('.popup-modal__close')
    const bodyBlackout = document.querySelector('.body-blackout')

    modalTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        const { popupTrigger } = trigger.dataset
        triggerPopup( popupTrigger );
      })
    })

    function triggerPopup( popup ) {
      const popupModal = document.querySelector(`[data-popup-modal="${popup}"]`)

      if ( !popupModal ) {
        return false
      }

      popupModal.classList.add('is--visible')
      bodyBlackout.classList.add('is-blacked-out')
      
      popupModal.querySelector('.popup-modal__close').addEventListener('click', () => {
         popupModal.classList.remove('is--visible')
         bodyBlackout.classList.remove('is-blacked-out')
      })
      
      bodyBlackout.addEventListener('click', () => {
        // TODO: Turn into a function to close modal
        popupModal.classList.remove('is--visible')
        bodyBlackout.classList.remove('is-blacked-out')
      })
    }

  });

});